import styled from 'styled-components';

import { primaryFontFamily } from 'views/services/font-scheme';
import { baseColor, primaryColor } from 'views/services/color-scheme';

export const Slogan = styled.div`
  display: inline-block;
  margin-top: 48px;
  padding: 32px;
  border-radius: 8px;
  font-family: ${primaryFontFamily};
  line-height: 2;
  color: ${baseColor};
  background-color: ${primaryColor};
  & > div:nth-child(1) {
    font-size: 40px;
  }
  & > div:nth-child(2) {
    margin-top: 24px;
    font-size: 16px;
  }
`;
